export const LIBRARY_VIEWS = [
  { id: 'capabilities', label: 'Capabilities', path: '/library' },
  { id: 'knowledge', label: 'Knowledge', path: '/contexts' },
  { id: 'projects', label: 'Projects', path: '/collections' },
];
export function getLibraryView(pathname) {
  if (pathname === '/' || /^\/library(?:\/|$)/.test(pathname)) return 'capabilities';
  if (/^\/contexts(?:\/|$)/.test(pathname)) return 'knowledge';
  if (/^\/collections(?:\/|$)/.test(pathname)) return 'projects';
  return null;
}
export function rememberedLibraryPath(userId) {
  try {
    const path = localStorage.getItem(`promptcrew:library-view:${userId}`);
    return LIBRARY_VIEWS.some((view) => view.path === path) ? path : '/library';
  } catch { return '/library'; }
}
